import { useEffect, useState } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import usePdfDocument from 'app/documents/hooks/usePdfDocument';
import LoadingScreen from 'app/common/components/LoadingScreen';
import useToast, { ToastStatuses } from 'app/common/hooks/useToast';

interface FileDownloadPagePathParams extends Record<string, string> {
  slug: string;
  folderId: string;
  fileId: string;
}

const FileDownload = () => {
  const { slug, folderId, fileId } = useParams<FileDownloadPagePathParams>();
  const { handleDownloadDocumentByUrlParams } = usePdfDocument();
  const { openToast } = useToast();

  const [redirectLogin, setRedirectLogin] = useState(false);
  const [redirectDocuments, setDedirectDocuments] = useState(false);

  const location = useLocation();

  useEffect(() => {
    // Timeout just for prevent API calling twice (unknown reason for mount/unmounting happening)
    const timeout = setTimeout(async () => {
      try {
        const success = await handleDownloadDocumentByUrlParams(folderId, fileId);

        if (!success) {
          setRedirectLogin(true);
        } else {
          setDedirectDocuments(true);
        }
      } catch (err: any) {
        // TODO: refactor API error handling
        if (err.message === 'FILE_FOLDER_NOT_FOUND') {
          openToast({
            title: 'File not found',
            description: 'The file you requested could not be found.',
            status: ToastStatuses.ERROR,
          });

          setDedirectDocuments(true);
        }
      }
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [handleDownloadDocumentByUrlParams, openToast, slug, folderId, fileId]);

  if (redirectLogin) {
    return <Navigate to={`/${slug}?redirectPath=${location.pathname}`} />;
  }

  if (redirectDocuments) {
    return <Navigate to="/app/documents" />;
  }

  return <LoadingScreen />;
};

export default FileDownload;
